module.exports = __webpack_public_path__ + "assets/img/logo.2de701aa.png";